<template>
 <div class="col-md-12 mr-auto ml-auto">
  <div class="wizard-container">
   <div class="card card-wizard active exemplar-layout-card" data-color="primary">
    <Form @submit="onSubmit">
     <div class="card-body">
      <Field name="bibDocumentoId" type="hidden" v-model="model.bibDocumentoId" />
      <p v-if="descricaoDocumento" class="mb-3 fw-semibold text-primary fs-5">{{ descricaoDocumento }}</p>
      <div class="d-flex align-items-center gap-2 flex-wrap">
       <BarraBotoes
        :loadingSave="loadingSave"
        :idRegistroCarregado="selectedId ? String(selectedId) : ''"
        :showSalvar="true"
        :gridViewLink="getRouteContext().searchViewLink"
        @limpar="limparFormulario"
        @excluir="excluir"
       />
       <button
        v-if="showCopyButton"
        type="button"
        class="btn btn-primary ms-2 px-4 py-2 rounded-3"
        :disabled="loadingCopy"
        @click="abrirPopupCopiar"
       >
        Copiar
       </button>
      </div>

      <div v-if="mostrarPopupCopiar" class="modal-backdrop-custom">
       <div class="modal-custom">
        <div class="modal-header-custom">
         <h5 class="mb-0">Copiar</h5>
        </div>

        <div class="modal-body-custom">
         <label for="quantidadeCopias" class="form-label">Quantidade de cópias</label>
         <input
          id="quantidadeCopias"
          v-model.number="quantidadeCopias"
          class="form-control"
          type="number"
          min="1"
          step="1"
         />
        </div>

        <div class="modal-footer-custom">
         <button type="button" class="btn btn-secondary" @click="cancelarPopupCopiar">
          Cancelar
         </button>
         <button type="button" class="btn btn-primary" :disabled="loadingCopy" @click="confirmarPopupCopiar">
          Ok
         </button>
        </div>
       </div>
      </div>

      <div class="row g-3 mt-1">
       <div class="col-xl-4 col-lg-5">
        <div class="card h-100 shadow-sm">
         <div class="card-body">
          <ConsulteGrid
           :key="gridKey"
           :columns="gridColumns"
           :data-source="dataSource"
           :actions="false"
           :hideHeader="true"
          >
           <template #body>
            <tr v-if="dataSource.loading">
             <td colspan="100%" style="height: 52.6px; padding-top: 10px">
              <div class="spinner-border text-primary exemplar-grid-loader"></div>
             </td>
            </tr>

            <tr v-else-if="gridRows.length === 0">
             <td colspan="100%"><i>Nenhum resultado</i></td>
            </tr>

            <tr
             v-for="row in gridRows"
             v-else
             :key="row.bibExemplarId"
             class="exemplar-grid-row"
             :class="{
              'exemplar-grid-row-selected': isRowSelected(row),
              'exemplar-grid-row-baixado': Number(row.baixado) === 1
             }"
            >
             <!-- A seleção é um <button> na célula: o @click ficava no <tr>, que o teclado não
                  alcança (WCAG 2.1.1). O "baixado" era só a cor vermelha; agora também é texto
                  para o leitor de tela (WCAG 1.4.1). -->
             <td>
              <button
               type="button"
               class="exemplar-grid-botao"
               :aria-pressed="isRowSelected(row) ? 'true' : 'false'"
               @click="selecionarRegistro(row)"
              >
               {{ row.identificacao || "-" }}
               <span v-if="Number(row.baixado) === 1" class="visually-hidden">(baixado)</span>
              </button>
             </td>
            </tr>
           </template>
          </ConsulteGrid>
         </div>
        </div>
       </div>

       <div class="col-xl-8 col-lg-7">
        <div class="card h-100 shadow-sm">
         <div class="card-body">
          <div class="row">
           <div class="col-12">
            <div class="col-3 mb-3 d-inline-block me-2">
             <div class="form-group">
              <label for="exemplar-tombamento">Tombamento</label>
              <Field
               id="exemplar-tombamento"
               name="identificacao"
               class="form-control"
               :class="{ 'readonly-field': !editarTombamento }"
               type="text"
               v-model="model.identificacao"
               :readonly="!editarTombamento"
               maxlength="30"
              />
              <ErrorMessage name="identificacao" />
             </div>
            </div>
            <div class="col-3 mb-3 d-inline-block">
             <div class="form-group">
              <label for="exemplar-codigo-barras">Código de Barras</label>
              <Field
               id="exemplar-codigo-barras"
               name="codigoBarra"
               class="form-control"
               :class="{ 'readonly-field': !editarCodigoBarras }"
               type="text"
               v-model="model.codigoBarra"
               :readonly="!editarCodigoBarras"
               maxlength="50"
              />
              <ErrorMessage name="codigoBarra" />
             </div>
            </div>
            <div class="col-6 mb-3">
             <div class="form-group">
              <DropDownListBibLocalizacao v-model="model.bibLocalizacaoId" />
              <ErrorMessage name="bibLocalizacaoId" />
             </div>
            </div>
            <div class="col-3 mb-3">
             <div class="form-group">
              <label for="campo-dataAquisicao-02ad">Data de Aquisição</label>
              <input
               v-model="model.dataAquisicao"
               class="form-control"
               type="date"
               name="dataAquisicao"
               id="campo-dataAquisicao-02ad"
              />
              <ErrorMessage name="dataAquisicao" />
             </div>
            </div>
            <div class="col-6 mb-3">
             <div class="form-group">
              <DropDownListBibFormaAquisicao v-model="model.bibFormaAquisicaoId" />
              <ErrorMessage name="bibFormaAquisicaoId" />
             </div>
            </div>
            <div class="col-md-3 d-flex align-items-center mb-3">
             <div class="form-check">
              <Field
               id="podeEmprestar"
               name="podeEmprestar"
               class="form-check-input"
               type="checkbox"
               v-model="model.podeEmprestar"
               :value="1"
               :unchecked-value="0"
              />
              <label for="podeEmprestar" class="form-check-label">
               Pode Emprestar
              </label>
              <ErrorMessage name="podeEmprestar" />
             </div>
            </div>
            <div class="col-6 mb-3">
             <div class="form-group">
              <label>Observação</label>
              <Field
               name="observacao"
               class="form-control"
               as="textarea"
               rows="4"
               v-model="model.observacao"
              />
              <ErrorMessage name="observacao" />
             </div>
            </div>
            <div class="col-md-3 d-flex align-items-center mb-3">
             <div class="form-check">
              <Field
               id="baixado"
               name="baixado"
               class="form-check-input"
               type="checkbox"
               v-model="model.baixado"
               :value="1"
               :unchecked-value="0"
               @change="onBaixadoChange"
              />
              <label for="baixado" class="form-check-label">
               Baixado
              </label>
              <ErrorMessage name="baixado" />
             </div>
            </div>
            <div class="col-3 mb-3" v-show="Number(model.baixado) === 1">
             <div class="form-group">
              <label>Data da Baixa</label>
              <Field
               name="dataBaixa"
               class="form-control"
               type="date"
               v-model="model.dataBaixa"
              />
              <ErrorMessage name="dataBaixa" />
             </div>
            </div>
            <div class="col-6 mb-3" v-show="Number(model.baixado) === 1">
             <div class="form-group">
              <DropDownListBibMotivoBaixa v-model="model.bibMotivoBaixaId" />
              <ErrorMessage name="bibMotivoBaixaId" />
             </div>
            </div>
           </div>
          </div>
         </div>
        </div>
       </div>
      </div>
     </div>
    </Form>
   </div>
  </div>
 </div>
</template>

<script lang="ts">
import { Form, Field, ErrorMessage } from "vee-validate";
import { defineComponent } from "vue";
import * as yup from "yup";
import BarraBotoes from "@/components/formulario/BarraBotoes.vue";
import DropDownListBibFormaAquisicao from "@/components/formulario/Biblioteca/DropDownListBibFormaAquisicao.vue";
import DropDownListBibLocalizacao from "@/components/formulario/Biblioteca/DropDownListBibLocalizacao.vue";
import DropDownListBibMotivoBaixa from "@/components/formulario/Biblioteca/DropDownListBibMotivoBaixa.vue";
import ConsulteGrid from "@/components/grid/ConsulteGrid.vue";
import BibExemplarDataSource from "@/datasources/biblioteca/bibexemplar/index.datasource";
import { ConsulteGridColumnsModel } from "@/datasources/consulte-grid";
import { BibExemplarModel } from "@/models/biblioteca/bibexemplar/bibexemplar.model";
import BibExemplarService from "@/services/biblioteca/bibexemplar/bibexemplar.service";
import { BibDocumentoModel } from "@/models/biblioteca/bibdocumento/bibdocumento.model";
import BibDocumentoService from "@/services/biblioteca/bibdocumento/bibdocumento.service";
import BibDocumentoAutorService from "@/services/biblioteca/bibdocumento/bibdocumentoautorservice";
import BibAutorService from "@/services/biblioteca/bibautor/bibautor.service";
import toastService from "@/services/globals/toast.service";
import { useEdicaoExemplar } from '@/composables/useEdicaoExemplar';

export default defineComponent({
 name: "CadastroComGrid",
 setup() { return useEdicaoExemplar(); },
 components: {
  BarraBotoes,
  ConsulteGrid,
  DropDownListBibLocalizacao,
  DropDownListBibFormaAquisicao,
  DropDownListBibMotivoBaixa,
  Form,
  Field,
  ErrorMessage,
 },
 data() {
  return {
   schema: yup.object({
    bibDocumentoId: yup.number().required().label("BibDocumentoId"),
    gesEscolaId: yup.number().label("GesEscolaId"),
    bibVolumeId: yup.number().label("BibVolumeId"),
    identificacao: yup.string().max(30).label("Tombamento"),
    bibLocalizacaoId: yup.number().label("BibLocalizacaoId"),
    codigoBarra: yup.string().max(50).label("Código de Barras"),
    dataAquisicao: yup.date().required().label("Data de Aquisição"),
    bibFormaAquisicaoId: yup.number().label("BibFormaAquisicaoId"),
    podeEmprestar: yup.number().required().label("Pode Emprestar"),
    baixado: yup.number().label("Baixado"),
    bibExemparAnteriorId: yup.number().label("BibExemparAnteriorId"),
    bibMotivoBaixaId: yup.number().label("BibMotivoBaixaId"),
    dataBaixa: yup.date().label("Data da Baixa"),
    observacao: yup.string().max(2000).label("Observação"),
   }),
   model: new BibExemplarModel() as BibExemplarModel,
   documento: null as BibDocumentoModel | null,
   loadingSave: false,
   loadingCopy: false,
   mostrarPopupCopiar: false,
   quantidadeCopias: 1 as number,
   gridKey: 0 as number,
   loadedRecordId: null as number | null,
   lastLoadedBibDocumentoId: 0 as number,
   dataSource: new BibExemplarDataSource(0, 10, 0, 0, []),
   gridColumns: [
    {
     text: "Tombamento",
     align: "center",
     cellsalign: "center",
     datafield: "identificacao",
     editable: false,
     filtertype: "text",
     filterable: true,
    },
   ] as ConsulteGridColumnsModel[],
  };
 },

 computed: {
  descricaoDocumento(): string {
   if (!this.documento) return "";
   const { titulo, subTitulo, autor } = this.documento;
   return `${titulo || ""}${subTitulo ? "-" + subTitulo : ""}. Autor: ${autor || ""}`;
  },
  gridRows(): BibExemplarModel[] {
   return this.dataSource.rows || [];
  },
  selectedId(): number | null {
   return this.getRouteContext().selectedId;
  },
  showCopyButton(): boolean {
   return this.gridRows.length > 0 && !!this.selectedId && !this.getRouteContext().isNewMode;
  },
 },

 methods: {
  async carregarDocumento() {
   const { bibDocumentoId } = this.getRouteContext();
   this.documento = null;
   if (!bibDocumentoId) return;
   try {
    const [documento, vinculos] = await Promise.all([
     BibDocumentoService.get(bibDocumentoId),
     BibDocumentoAutorService.get(bibDocumentoId),
    ]);
    const autores = await Promise.all((vinculos?.bibAutorId ?? []).map(id => BibAutorService.get(id)));
    documento.autor = autores
     .map(autor => [autor.sobreNome, autor.nome].filter(Boolean).join(", "))
     .join("; ");
    if (this.getRouteContext().bibDocumentoId === bibDocumentoId) this.documento = documento;
   } catch {
    if (this.getRouteContext().bibDocumentoId === bibDocumentoId) {
     toastService.alertaErro("Não foi possível carregar a descrição do documento.");
    }
   }
  },
  formatDateForInput(value: unknown) {
   if (!value) return undefined;
   if (typeof value === "string") {
    return value.length >= 10 ? value.substring(0, 10) : value;
   }
   if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
   }
   return undefined;
  },

  getRouteContext() {
   const routeName = String(this.$route.name || "");
   const isCentral =
    routeName.includes("_central") ||
    this.$route.path.includes("/cadastro/0/") ||
    this.$route.path.includes("/cadastroexemplar/0/");
   const bibDocumentoId =
    Number(this.$route.params.bibDocumentoId) ||
    Number(this.$route.query.bibDocumentoId) ||
    Number(this.model.bibDocumentoId) ||
    0;
   const selectedId =
    Number(this.$route.query.id) ||
    Number(this.$route.params.id) ||
    0;

   return {
    isCentral,
    bibDocumentoId,
    selectedId: selectedId || null,
    isNewMode: String(this.$route.query.novo || "") === "1",
    gridRouteName: isCentral ? "bibexemplar_grid_central" : "bibexemplar_grid_escola",
    searchViewLink: `/biblioteca/bibexemplar/${isCentral ? "0" : "1"}`,
   };
  },

  async ensureCanonicalRoute() {
   const { bibDocumentoId, selectedId, isNewMode, gridRouteName } = this.getRouteContext();
   if (!bibDocumentoId) return false;

   if (
    this.$route.name !== gridRouteName ||
    Number(this.$route.params.bibDocumentoId) !== bibDocumentoId
   ) {
    await this.replaceRoute(selectedId, isNewMode);
    return true;
   }

   return false;
  },

  async replaceRoute(idRegistro: number | null = null, novo = false) {
   const { gridRouteName, bibDocumentoId } = this.getRouteContext();
   const query: Record<string, string> = {};

   if (idRegistro) {
    query.id = String(idRegistro);
   }

   if (novo) {
    query.novo = "1";
   }

   const targetRoute = {
    name: gridRouteName,
    params: { bibDocumentoId: String(bibDocumentoId) },
    query,
   };
   const currentFullPath = this.$route.fullPath;
   const targetFullPath = this.$router.resolve(targetRoute).fullPath;

   if (currentFullPath === targetFullPath) {
    return;
   }

   await this.$router.replace(targetRoute);
  },

  async reloadGrid() {
   this.gridKey += 1;
   await this.dataSource.filter(this.dataSource.rowsPerPage || 10);
  },

  async prepareNewModel() {
   const { bibDocumentoId, isCentral } = this.getRouteContext();
   const novoModel = new BibExemplarModel();
   const ultimoRegistroGrid = this.gridRows[this.gridRows.length - 1];

   novoModel.bibDocumentoId = bibDocumentoId;
   novoModel.gesEscolaId = isCentral ? 0 : novoModel.gesEscolaId;
   novoModel.identificacao = "";
   novoModel.codigoBarra = "";

   if (ultimoRegistroGrid?.bibExemplarId) {
    try {
     const ultimoRegistro = await BibExemplarService.get(Number(ultimoRegistroGrid.bibExemplarId));
     novoModel.bibLocalizacaoId = ultimoRegistro.bibLocalizacaoId;
     novoModel.dataAquisicao = this.formatDateForInput(ultimoRegistro.dataAquisicao) as unknown as Date;
     novoModel.bibFormaAquisicaoId = ultimoRegistro.bibFormaAquisicaoId;
    } catch (error) {
     console.error("Erro ao carregar último exemplar para novo registro:", error);
    }
   }

   this.model = novoModel;
   this.loadedRecordId = null;
  },

  async carregarFormulario(idRegistro: number | null) {
   if (!idRegistro) {
    await this.prepareNewModel();
    return;
   }

   const registro = await BibExemplarService.get(idRegistro);
   this.model = registro;
   this.model.dataAquisicao = this.formatDateForInput(this.model.dataAquisicao) as unknown as Date;
   this.model.dataBaixa = this.formatDateForInput(this.model.dataBaixa) as unknown as Date;
   this.model.podeEmprestar = Number(this.model.podeEmprestar) === 1 ? 1 : 0;
   this.model.baixado = Number(this.model.baixado) === 1 ? 1 : 0;
   this.loadedRecordId = idRegistro;
  },

  async syncScreenFromRoute() {
   const { selectedId, isNewMode } = this.getRouteContext();

   if (selectedId && !isNewMode) {
    if (this.loadedRecordId !== selectedId) {
     try {
      await this.carregarFormulario(selectedId);
     } catch (error) {
      console.error("Erro ao carregar BibExemplar:", error);
     }
    }
    return;
   }

   if (this.loadedRecordId !== null || Number(this.model.bibExemplarId || 0) !== 0 || isNewMode) {
    await this.prepareNewModel();
   }
  },

  async handleRouteChange() {
   const redirected = await this.ensureCanonicalRoute();
   if (redirected) return;

   await this.syncScreenFromRoute();
  },

  async onGridLoaded(source: BibExemplarDataSource) {
   const { selectedId, isNewMode } = this.getRouteContext();
   const rows = source.rows || [];

   if (rows.length === 0) {
    await this.prepareNewModel();
    if (selectedId || !isNewMode) {
     await this.replaceRoute(null, true);
    }
    return;
   }

   if (isNewMode) {
    await this.prepareNewModel();
    return;
   }

   if (selectedId && rows.some((row) => Number(row.bibExemplarId) === Number(selectedId))) {
    return;
   }

   const firstId = Number(rows[0].bibExemplarId) || null;
   if (firstId) {
    await this.replaceRoute(firstId, false);
   }
  },

  async limparFormulario() {
   await this.prepareNewModel();
   await this.replaceRoute(null, true);
  },

  async selecionarRegistro(row: BibExemplarModel) {
   const idRegistro = Number(row.bibExemplarId) || null;
   if (!idRegistro || idRegistro === this.selectedId) return;
   await this.replaceRoute(idRegistro, false);
  },

  isRowSelected(row: BibExemplarModel) {
   return Number(row.bibExemplarId) === Number(this.selectedId || 0);
  },

  onBaixadoChange(event: Event) {
   const checked = (event.target as HTMLInputElement)?.checked === true;
   this.model.baixado = checked ? 1 : 0;
   if (this.model.baixado !== 1) {
    this.model.dataBaixa = undefined;
    this.model.bibMotivoBaixaId = 0;
   }
  },

  abrirPopupCopiar() {
   if (!this.showCopyButton) return;
   this.quantidadeCopias = 1;
   this.mostrarPopupCopiar = true;
  },

  cancelarPopupCopiar() {
   this.mostrarPopupCopiar = false;
   this.quantidadeCopias = 1;
  },

  buildCopyModel() {
   const { bibDocumentoId, isCentral } = this.getRouteContext();
   const copyModel = new BibExemplarModel();

   copyModel.bibDocumentoId = bibDocumentoId;
   copyModel.gesEscolaId = isCentral ? 0 : this.model.gesEscolaId;
   copyModel.bibVolumeId = this.model.bibVolumeId;
   copyModel.bibLocalizacaoId = this.model.bibLocalizacaoId;
   copyModel.dataAquisicao = this.model.dataAquisicao;
   copyModel.bibFormaAquisicaoId = this.model.bibFormaAquisicaoId;
   copyModel.podeEmprestar = Number(this.model.podeEmprestar) === 1 ? 1 : 0;
   copyModel.observacao = this.model.observacao ?? "";
   copyModel.identificacao = "";
   copyModel.codigoBarra = "";
   copyModel.baixado = 0;
   copyModel.dataBaixa = undefined;
   copyModel.bibMotivoBaixaId = 0;
   copyModel.bibExemparAnteriorId = Number(this.selectedId) || 0;

   return copyModel;
  },

  async confirmarPopupCopiar() {
   const quantidade = Number(this.quantidadeCopias);

   if (!this.selectedId || !this.showCopyButton) {
    this.cancelarPopupCopiar();
    return;
   }

   if (!Number.isInteger(quantidade) || quantidade < 1) {
    toastService.alertaErro("Informe uma quantidade de cópias válida.");
    return;
   }

   this.loadingCopy = true;

   try {
    let ultimoId: number | null = null;

    for (let index = 0; index < quantidade; index += 1) {
     const response = await BibExemplarService.inserirAtualizar(this.buildCopyModel());
     ultimoId = Number(response.data.codigo) || ultimoId;
    }

    toastService.alertaSucesso("Cópias incluídas com sucesso!");
    this.cancelarPopupCopiar();
    await this.reloadGrid();

    if (ultimoId) {
     await this.replaceRoute(ultimoId, false);
    }
   } catch (error) {
    console.error("Erro ao copiar BibExemplar:", error);
    toastService.alertaErro("Ocorreu um erro ao copiar o registro.");
   } finally {
    this.loadingCopy = false;
   }
  },

  async excluir() {
   if (!this.selectedId) return;

   await BibExemplarService.remover(this.selectedId);
   toastService.alertaSucesso("Registro excluído com sucesso!");
   this.loadedRecordId = null;
   await this.reloadGrid();
  },

  async onSubmit() {
   const { bibDocumentoId, isCentral } = this.getRouteContext();
   this.model.bibDocumentoId = bibDocumentoId;
   this.model.gesEscolaId = isCentral ? 0 : this.model.gesEscolaId;

   if (!this.model.bibDocumentoId) {
    toastService.alertaErro("BibDocumentoId é obrigatório.");
    return;
   }

   if (!this.model.dataAquisicao) {
    toastService.alertaErro("Data de Aquisição é obrigatória.");
    return;
   }

   if (this.selectedId) {
    this.model.bibExemplarId = this.selectedId;
   }

   this.loadingSave = true;
   try {
    const response = await BibExemplarService.inserirAtualizar(this.model);
    toastService.alertaSucesso("Dados registrados com sucesso!");
    await this.replaceRoute(response.data.codigo, false);
    await this.reloadGrid();
   } catch (error) {
    console.error("Erro ao salvar BibExemplar:", error);
    toastService.alertaErro("Ocorreu um erro ao executar a ação.");
   } finally {
    this.loadingSave = false;
   }
  },
 },

 async mounted() {
  this.dataSource.setOnLoad((source) => this.onGridLoaded(source as BibExemplarDataSource));
  const redirected = await this.ensureCanonicalRoute();
  if (redirected) return;

  const { bibDocumentoId } = this.getRouteContext();
  if (bibDocumentoId) {
   this.lastLoadedBibDocumentoId = bibDocumentoId;
   await this.carregarDocumento();
   await this.reloadGrid();
  }
  await this.syncScreenFromRoute();
 },

 watch: {
  "$route.params.bibDocumentoId": {
   async handler() {
    const redirected = await this.ensureCanonicalRoute();
    if (redirected) return;

    const { bibDocumentoId } = this.getRouteContext();
    if (bibDocumentoId && this.lastLoadedBibDocumentoId !== bibDocumentoId) {
     this.lastLoadedBibDocumentoId = bibDocumentoId;
     await this.carregarDocumento();
     await this.reloadGrid();
    }
   },
   immediate: false,
  },
  "$route.query.id": {
   async handler() {
    await this.handleRouteChange();
   },
   immediate: false,
  },
  "$route.query.novo": {
   async handler() {
    await this.handleRouteChange();
   },
   },
  },
});
</script>

<style scoped>
.readonly-field {
 background-color: #e9ecef;
}

.exemplar-layout-card {
 overflow: hidden;
}

.exemplar-grid-row {
 cursor: pointer;
 transition: background-color 0.2s ease;
}

.exemplar-grid-botao {
 display: block;
 width: 100%;
 padding: 0;
 border: 0;
 background: transparent;
 color: inherit;
 font: inherit;
 text-align: start;
 cursor: pointer;
}

.exemplar-grid-row:hover {
 background-color: #f4f7ff;
}

.exemplar-grid-row-selected {
 background-color: #e8f0ff;
}

.exemplar-grid-row-baixado td {
 color: #dc3545;
}

.exemplar-grid-loader {
 position: absolute;
 left: 46%;
}

.modal-backdrop-custom {
 position: fixed;
 inset: 0;
 background-color: rgba(0, 0, 0, 0.4);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 1050;
}

.modal-custom {
 background: #fff;
 border-radius: 12px;
 width: 100%;
 max-width: 420px;
 box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
 overflow: hidden;
}

.modal-header-custom,
.modal-body-custom,
.modal-footer-custom {
 padding: 1rem 1.25rem;
}

.modal-header-custom {
 border-bottom: 1px solid #dee2e6;
}

.modal-footer-custom {
 border-top: 1px solid #dee2e6;
 display: flex;
 justify-content: flex-end;
 gap: 0.75rem;
}

@media (max-width: 991px) {
 .card-header h5 {
  margin-bottom: 0.75rem;
 }
}
</style>
